var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flag-item",style:({
    backgroundImage: _vm.svgFlag
      ? ("url('data:image/svg+xml," + (encodeURIComponent(_vm.svgFlag)) + "')")
      : 'none',
  })})}
var staticRenderFns = []

export { render, staticRenderFns }